import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";

const AttemptedUserModal = ({ user, onHide }) => {
  const [isItalian, setIsItalian] = useState(false);

  useEffect(() => {
    const language = localStorage.getItem('language');
    setIsItalian(language === 'Italian');

    if (language === 'Italian') {
      require('moment/locale/it');
      moment.locale('it');
    } else {
      moment.locale('en');
    }
  }, []);

  if (!user) return null;

  const formatDate = (dateString) => {
    if (!dateString) return isItalian ? "N/D" : "N/A";
    return moment(new Date(dateString)).format("DD MMM, YYYY");
  };

  const calculateAge = (dob) => {
    if (!dob) return isItalian ? "N/D" : "N/A";
    const years = moment().diff(moment(dob), 'years');
    const months = moment().diff(moment(dob), 'months') % 12;

    if (years === 0) {
      if (isItalian) {
        return `${months} ${months === 1 ? 'mese' : 'mesi'}`;
      } else {
        return `${months} ${months === 1 ? 'month' : 'months'}`;
      }
    }
    return `${years}`;
  };

  const text = {
    userDetails: isItalian ? "Dettagli Utente" : "User Details",
    userInfo: isItalian ? "Informazioni Utente" : "User Information", 
    age: isItalian ? "Età" : "Age",
    country: isItalian ? "Paese" : "Country",
    region: isItalian ? "Regione" : "Region",
    province: isItalian ? "Provincia" : "Province",
    comune: isItalian ? "Comune" : "Municipality",
    state: isItalian ? "Stato" : "State",
    city: isItalian ? "Città" : "City",
    gender: isItalian ? "Genere" : "Gender",
    education: isItalian ? "Istruzione" : "Education",
    civilState: isItalian ? "Stato Civile" : "Civil Status",
    close: isItalian ? "Chiudi" : "Close"
  };

  return (
    <Modal show={true} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{text.userDetails}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="user-profile-header d-flex align-items-center mb-4">
          <div className="me-3">
            <img
              src={user.image ? `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${user.image}` : `${process.env.PUBLIC_URL}/images/no_profile.png`}
              alt={user.name}
              className="rounded-circle"
              style={{ width: "80px", height: "80px", objectFit: "cover" }}
            />
          </div>
          <div>
            <h4 className="mb-1">{user.name}</h4>
            <p className="text-muted mb-0">{user.email}</p>
          </div>
        </div>

        <div className="card">
          <div className="card-header bg-light">
            <h5 className="mb-0">{text.userInfo}</h5>
          </div>
          <ul className="list-group list-group-flush">
            {user.dob?.isVisible && (
              <li className="list-group-item d-flex justify-content-between">
                <span className="fw-medium">{text.age}:</span>
                <span>{calculateAge(user.dob?.date)}</span>
              </li>
            )}

            {user.nation_country?.isVisible && user.countryName && user.countryName.length > 0 && (
              <li className="list-group-item d-flex justify-content-between">
                <span className="fw-medium">{text.country}:</span>
                <span>{user.countryName[0]?.name || (isItalian ? "N/D" : "N/A")}</span>
              </li>
            )}

            {user.nation_country?.id === "107" ? (
              <>
                {user.region?.isVisible && user.regionName && user.regionName.length > 0 && (
                  <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-medium">{text.region}:</span>
                    <span>{user.regionName[0]?.DescrRegione || (isItalian ? "N/D" : "N/A")}</span>
                  </li>
                )}
                {user.provincia?.isVisible && user.provinciaName && user.provinciaName.length > 0 && (
                  <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-medium">{text.province}:</span>
                    <span>{user.provinciaName[0]?.DescrProvincia || (isItalian ? "N/D" : "N/A")}</span>
                  </li>
                )}
                {user.comune?.isVisible && user.comuneName && user.comuneName.length > 0 && (
                  <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-medium">{text.comune}:</span>
                    <span>{user.comuneName[0]?.DescrComune || (isItalian ? "N/D" : "N/A")}</span>
                  </li>
                )}
              </>
            ) : (
              <>
                {user.region_state?.isVisible && user.stateName && user.stateName.length > 0 && (
                  <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-medium">{text.state}:</span>
                    <span>{user.stateName[0]?.name || (isItalian ? "N/D" : "N/A")}</span>
                  </li>
                )}
                {user.city?.isVisible && user.cityName && user.cityName.length > 0 && (
                  <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-medium">{text.city}:</span>
                    <span>{user.cityName[0]?.name || (isItalian ? "N/D" : "N/A")}</span>
                  </li>
                )}
              </>
            )}

            {user.gender?.isVisible && (
              <li className="list-group-item d-flex justify-content-between">
                <span className="fw-medium">{text.gender}:</span>
                <span className="notranslate" translate="no">{user?.gender?.name}</span>
              </li>
            )}
            {user.education?.isVisible && (
              <li className="list-group-item d-flex justify-content-between">
                <span className="fw-medium">{text.education}:</span>
                <span>{user.education.name}</span>
              </li>
            )}
            {user.civilState?.isVisible && (
              <li className="list-group-item d-flex justify-content-between">
                <span className="fw-medium">{text.civilState}:</span>
                <span>{user.civilState.name}</span>
              </li>
            )}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {text.close}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AttemptedUserModal;